export default __webpack_public_path__ + "static/media/vehicle90.34615157.svg";